import React, { useEffect } from 'react';
import { Space, Card } from 'antd';
import { dateFormat } from '../utils';
import W from '../assets/W.png';
import U from '../assets/U.png';
import B from '../assets/B.png';
import R from '../assets/R.png';
import G from '../assets/G.png'; 
import Zero from '../assets/0.png';
import One from '../assets/1.png';
import Two from '../assets/2.png';
import Three from '../assets/3.png';
import Four from '../assets/4.png';
import Five from '../assets/5.png';
import Six from '../assets/6.png';
import Seven from '../assets/7.png';
import Eight from '../assets/8.png';
import Nine from '../assets/9.png';
import Ten from '../assets/10.png';
import Simic from '../assets/UG.png';
import Dimir from '../assets/UB.png';
import Golgari from '../assets/BG.png';
import Rakdos from '../assets/BR.png';
import Gruul from '../assets/RG.png';
import Selesnya from '../assets/WG.png';
import Orzhov from '../assets/WB.png';
import Izzet from '../assets/UR.png';
import Azorius from '../assets/WU.png';
import Boros from '../assets/WR.png';
import PhyrexianRed from '../assets/RP.png';
import PhyrexianGreen from '../assets/GP.png';
import PhyrexianBlue from '../assets/UP.png';
import PhyrexianWhite from '../assets/WP.png';
import PhyrexianBlack from '../assets/BP.png';

const arrayColorsIcon = {
    '{W}': W,
    '{U}': U,
    '{B}': B,
    '{R}': R,
    '{G}': G,
    '{0}': Zero,
    '{1}': One,
    '{2}': Two,
    '{3}': Three,
    '{4}': Four,
    '{5}': Five,
    '{6}': Six,
    '{7}': Seven,
    '{8}': Eight,
    '{9}': Nine,
    '{10}': Ten,
    '{U/G}': Simic,
    '{U/B}': Dimir,
    '{B/G}': Golgari,
    '{B/R}': Rakdos,
    '{R/G}': Gruul,
    '{W/G}': Selesnya,
    '{W/B}': Orzhov,
    '{U/R}': Izzet,
    '{W/U}': Azorius,
    '{W/R}': Boros,
    '{R/P}': PhyrexianRed,
    '{G/P}': PhyrexianGreen,
    '{U/P}': PhyrexianBlue,
    '{W/P}': PhyrexianWhite,
    '{B/P}': PhyrexianBlack
}

function ShowCardColors(props) {
    // console.warn('props di showcardcolors', { card: props.card });
    if (props.card && props.card.mana_cost && props.card.mana_cost !== '' && !props.card.mana_cost.includes('//')) {
        // console.warn('props.card.card_faces di ', props.card.name, ': ', props.card.card_faces);
        // card mana cost is a string like "{1}{U}{U}" or "{2}{G}{G}{G}"
        // split the string into an array of strings like ["{1}", "{U}", "{U}"] or ["{2}", "{G}", "{G}", "{G}"]
        const manaCostArray = props.card.mana_cost.match(/(\{[^\}]+\})/g);
        // console.warn('manaCostArray: ', manaCostArray);
        let retVal = [];
        if (manaCostArray) {
            manaCostArray.forEach((currentItem) =>{
                if (arrayColorsIcon[currentItem]) {
                    retVal.push(<span><img src={arrayColorsIcon[currentItem]} style={{ width: '16px'}}/></span>)
                }
            })
        }

        return (
        <span style={{ float: 'right', marginRight: '10px' }}>
            {retVal.map(color => color)}
        </span>
        ); 
    }

    if (props.card && props.card.card_faces) {
        // console.warn('props.card.card_faces di ', props.card.name, ': ', props.card.card_faces);
        let manaCosts = [];
        let retVal = [];
        // console.warn('props.card.card_faces: ', props.card.card_faces);
        props.card.card_faces.forEach((face) => {
            if (face.mana_cost !== '') {
                manaCosts.push(face.mana_cost);
            }
        });
        // props.card.mana_cost = manaCosts;
        // console.warn('props.card.mana_cost after merging: ', manaCosts);
        // card mana cost is a string like "{1}{U}{U}" or "{2}{G}{G}{G}"
        // split the string into an array of strings like ["{1}", "{U}", "{U}"] or ["{2}", "{G}", "{G}", "{G}"]
        if (manaCosts.length > 1) {
            for (let i = 0; i < manaCosts.length; i++) {
                const manaCostArray = manaCosts[i].match(/(\{[^\}]+\})/g);
                // console.warn('manaCostArray: ', manaCostArray);
                if (manaCostArray) {
                    manaCostArray.forEach((currentItem) =>{
                        if (arrayColorsIcon[currentItem]) {
                            retVal.push(<span><img src={arrayColorsIcon[currentItem]} style={{ width: '16px'}}/></span>)
                        }
                    })
                }
                if (i === 0) {
                    retVal.push(<span style={{ marginLeft: '2px', marginRight: '2px', fontWeight: 'bold' }}>//</span>);
                }
            }
        }

        return (
        <span style={{ float: 'right', marginRight: '10px' }}>
            {retVal.map(color => color)}
        </span>
        ); 
    }


    return (<Space></Space>)
}

export default ShowCardColors;